import {
  SET_NEXT_CALLBACK_FUNCTION,
  SET_SHOW_MODAL,
  SET_UNSAVED_CHANGES,
  UnsavedChangesModalModuleActionTypes,
  UnsavedChangesModalModuleState
} from "./types";

const initialState: UnsavedChangesModalModuleState = {
  showModal: false,
  nextTemplate: null,
  hasUnsavedChanges: false,
  nextCallback: undefined
};

export const unsavedChangesModalReducer = (
  state = initialState,
  action: UnsavedChangesModalModuleActionTypes
): UnsavedChangesModalModuleState => {
  switch (action.type) {
    case SET_SHOW_MODAL:
      return {
        ...state,
        showModal: action.meta.params.showModal,
        nextTemplate: action.meta.params.nextTemplate ?? null
      };
    case SET_UNSAVED_CHANGES:
      return {
        ...state,
        hasUnsavedChanges: action.meta.params.hasUnsavedChanges
      };
    case SET_NEXT_CALLBACK_FUNCTION:
      return {
        ...state,
        nextCallback: action.meta.params.nextCallback
      };
    default:
      return state;
  }
};
